import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetDailyCheckIn from '@/modules/promotion/api/hooks/useQueryGetDailyCheckIn'
import DailyCheckInListing from '@/modules/promotion/components/DailyCheckIn/components/DailyCheckInListing'

function DailyCheckInPage() {
	const { pageSize, currentPage, selectedQuery } = useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		name: selectedQuery,
	}

	const { data, isLoading } = useQueryGetDailyCheckIn(payload)

	return (
		<PageContainer>
			<DailyCheckInListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedDailyCheckInPage = withUserPermission(DailyCheckInPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_DAILY_CHECK_IN],
})

export default GuardedDailyCheckInPage
